import { azureBlobFSMetadata } from 'app/registries/linked-service/azure-blob-fs-metadata';
import { IDynamicLinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { CommonResourceKind as ResourceKind, DataSourceOptionKind } from '@powerquery/mashup-editor-client';
import { cdcDestination } from 'app/registries/consts/metadata-consts';

export const sapDatasphereForAzureDataLakeStorageGen2Metadata: IDynamicLinkedServiceTypeMetadata = async (injector) => {
    const metadata = await azureBlobFSMetadata(injector);
    return {
        ...metadata,
        disabled: !__IS_FABRIC_DPE__,
        type: adfModelTypeMap.sapDatasphereForAzureDataLakeStorageGen2.linkedServiceType,
        displayName: stringResources.SapDatasphereForAzureDataLakeStorageGen2LinkedService_DisplayText,
        icon: {
            className: 'svg-i-100x100-Sap'
        },
        copySourceTypes: [],
        copySinkTypes: [],
        supportedJobModesAsSource: ['CDC'],
        pqoDataSourceOption: {
            kind: DataSourceOptionKind.Extension,
            resourceKind: 'SAPAzureDataLakeStorageGen2' as ResourceKind
        },
        category: ['File'],
        supportDataFlowSource: false,
        supportDataFlowSink: false,
        supportCopyJobSource: true,
        supportCopyJobSink: false,
        nativeCDCOnly: true,
        cdc: {
            supportCDC: true,
            supportedCDCDestinations: cdcDestination,
            GA: true
        },
        supportDatasetV2: true,
        linkedServiceNamePrefix: 'SAPAzureDataLakeStorage',
        supportFirstClassParameterExperience: false,
        controls: [],
        notSupportCopySink: true,
        notSupportDeleteActivity: true,
        supportGetMetadataActivity: false,
        supportStoredProcedureActivity: false,
        supportScriptActivity: false,
        supportAutoFillCopilotInput: false,
        isKnownInPipelineContext: false
    };
};
